<template>
    <div>
        <div class="flex items-start justify-between mb-4">
            <div>
                <h2 class="text-2xl font-semibold">Consolidation ID#</h2>
                <div>457906-04</div>
            </div>

            <div>
                <h3 class="text-lg font-semibold">Est. Consolidated cap. (Tonnes)</h3>
                <!-- <div>{{ fleetDetails.carriageCapacity }} Tons</div> -->
            </div>
        </div>
        <!-- {{ filterUndispatchedFleet  }} -->
        <div class="flex flex-wrap justify-between">
            <div class="flex flex-wrap w-full justify-between">
                <div class="places_wrapper mb-4" style="border: 1px solid #dae8f6; height: 200px">
                    <div class="pl-4 flex items-center font-semibold" style="background: #ecf3fb; height: 60px">
                        Origin
                    </div>

                    <div class="px-4 mt-4">
                        {{
                            currentLocation
                                ? currentLocation.location.locationName
                                : "No Location Selected"
                        }},
                        <br />
                        {{ currentLocation ? currentLocation.location.address : "" }}
                    </div>
                </div>

                <div class="mb-4 places_wrapper" style="border: 1px solid #dae8f6; height: 200px">
                    <div class="pl-4 flex items-center font-semibold" style="background: #cef1e8; height: 60px">
                        Destination
                    </div>

                    <div class="px-4 mt-4">
                        <label class="mb-1">Destination</label>

                        <el-select v-model="payload.destination" placeholder="Select Destinations">
                            <el-option v-for="location in locations" :key="location.id" :label="location.locationName"
                                :value="location.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>

            <div class="w-full flex flex-wrap justify-between">
                <div class="w-full md:w-6/12">
                    <label class="mb-1">Vehicle Type/ Carrying Capacity</label>
                    <div class="w-full flex items-center gap-3">
                        <el-select v-model="payload.vehicleType" placeholder="Select vehicle type">
                            <el-option v-for="vehicleType in fleetForConsolidation" :key="vehicleType.type"
                                :label="vehicleType.type" :value="vehicleType.type">
                            </el-option>
                        </el-select>

                        <el-select v-model="fleetCapacity" placeholder="Select fleet">
                            <el-option v-for="fleet in filterFleetByType" :key="fleet.capacity" :label="fleet.capacity"
                                :value="fleet.capacity">
                            </el-option>
                        </el-select>
                    </div>
                </div>

                <div class="w-full md:w-5/12">
                    <label class="mb-1">Plate Number</label>
                    <el-select v-model="payload.fleetId" placeholder="Select fleet">
                        <el-option v-for="fleet in filterFleetByTypeTonnage" :key="fleet.vehicleNumber"
                            :label="fleet.vehicleNumber" :value="fleet.id">
                        </el-option>
                    </el-select>
                    <p class="driver_details">
                        Driver: {{ driverName }}
                    </p>
                </div>
            </div>

            <div class="mt-5 w-full md:w-6/12">
                <label>Upload Documents</label>
                <div :style="{
                    'background-color': '#FBFCFE',
                    border: '1px solid #DAE8F6',
                }" class="pt-2 px-3 rounded-lg overflow-hidden flex justify-between pb-2 w-full">
                    <div :style="{ color: '#B7BDCD', fontSize: '16px' }" class="mt-1 w-9/12">
                        <p v-if="!isUploadingDoc && !docUploaded">Upload File</p>
                        <div v-if="isUploadingDoc" class="d-flex justify-content-center py-2 -mt-2">
                            <saving-loader :icon-color="'#0253B3'" />
                        </div>
                    </div>

                    <button @click="triggerUpload = true" :style="{
                        'background-color': '#CBE0F6',
                        height: '32px',
                        width: '91px',
                    }" class="rounded-lg w-3/12">
                        Upload
                    </button>
                </div>

                <div class="mt-3">
                    <div class="image_list" v-for="url in payload.documentUrl" :key="url">{{ url.substring(url.length -
                        20)
                        }}<button @click="removeImageUrl(url)">&#x2715;</button>
                    </div>
                </div>

                <document-upload hidden ref="documentUploader" @input="handleDocUpload($event)"
                    @closeTrigger="triggerUpload = false" @remove-image="removeImage" :docurl="docurl"
                    :triggerUpload="triggerUpload" :isUploadingImage="isUploadingDoc" />
            </div>

            <div class="mt-5">
                <div class="flex flex-no-wrap justify-between gap-2">
                    <p>Truck Capacity {{ " " }} </p>
                    <p v-if="fleetDetails != 'N.A'">
                        {{ calculateCapacity }}/{{ Number(fleetDetails.carriageCapacity) }} Tons
                    </p>
                </div>
                <div class="flex flex-row-reverse h-[17px] mt-4">
                    <div :style="{ 'background-color': '#D5F2EA' }" class="w-100 relative z-20 h-6 rounded-r-lg"
                        v-if="(calculateCapacity / Number(fleetDetails.carriageCapacity)) * 100 < 100"></div>
                    <div :style="{
                        'background-color': '#00C48C',
                        width:
                            fleetDetails != 'N.A'
                                ? (calculateCapacity / Number(fleetDetails.carriageCapacity)) *
                                100 +
                                '%'
                                : '0%',
                    }" class="h-6 relative z-10 rounded-l-lg"></div>
                </div>
            </div>
        </div>

        <div class="flex justify-between mt-5" style="height: 40px">
            <button class="h-full bg-charcoal text-white rounded font-semibold" style="width: 120px"
                @click="createConsolidation('consolidation-completed')">
                Complete
            </button>

            <div class="h-full">
                <button class="h-full font-semibold" style="width: 120px" @click="showConsolidationDialog = false">
                    Cancel
                </button>

                <primary-button class="h-full bg-primary-yellow rounded font-semibold" buttonText="Save"
                    style="width: 120px" :loading="isLoading" :disabled="!canSave"
                    @click="createConsolidation('in-progress')" />

            </div>
        </div>
    </div>
</template>

<script>
import SavingLoader from "@/components/UI/ButtonSavingLoader";

export default {
    components: {
        SavingLoader
    },
    data() {
        return {
            locations: [],
            fleetForConsolidation: [],
            isUploadingDoc: false,
            triggerUpload: false,
            fileName: null,
            docUploaded: false,
            isLoading: false,
            docurl: "",
            payload: {
                orgId: "",
                userId: "",
                origin: "",
                destination: "",
                vehicleType: "",
                plateNumber: "",
                driverName: "",
                destinationName: "",
                fleetId: "",
                documentUrl: [],
                consignees: [],
                status: "on-hold" // only needed for on hold
            },
        }
    },
    activated() {
        this.getAllLocations();
        this.getAllFleetsForConsolidation()
    },
    methods: {
        async handleDocUpload(image) {
            this.isUploadingDoc = true;
            this.triggerUpload = false;
            this.fileName = image.name;
            this.docUploaded = false;

            try {
                let response = await this.updateDocument(image);
                this.docurl = response;
                this.payload.documentUrl.push(response);
                this.isUploadingDoc = false;
                this.docUploaded = true;
                this.generateToast("Document uploaded", "success");
            } catch (error) {
                this.handleError(error);
                this.isUploadingDoc = false;
            }
        },
        async getAllLocations() {
            try {
                const response = await this.$_getAllLocations();

                this.log(response);
                this.locations = response.data.data.locations;
            } catch (error) {
                this.handleError(error);
            }
        },
        async getAllFleetsForConsolidation() {
            try {
                const response = await this.$_getAllFleetsForConsolidation();
                console.log(response?.data?.data, "all fleets for consolidation");
                this.fleetForConsolidation = response?.data?.data
            } catch (error) {
                this.handleError(error);
            }
        },
    },
    computed: {
        fleetDetails() {
            if (!this.payload.fleetId) return "N.A";
            return this.fleets.find((fleet) => fleet.id === this.payload.fleetId);
        },
        currentLocation() {
            return this.$store.getters.currentLocation;
        },
        driverName() {
            return `${this.filterFleetByTypeTonnage[0]?.user?.firstname || ""} ${this.filterFleetByTypeTonnage[0]?.user?.lastname || ""}`;
        },
        filterFleetByType() {
            const typeFleets = this.fleetForConsolidation.find(item => item.type === this.payload.vehicleType)?.fleets || [];
            return typeFleets;
        },
        filterFleetByTypeTonnage() {
            const vehicleFleets = this.filterFleetByType.filter(item => item.capacity === this.fleetCapacity) || [];
            return vehicleFleets;
        },
    },
}
</script>

<style lang="scss" scoped>
.driver_details {
  @apply py-1 px-2 bg-primary-blue/5 w-full text-center
}

.image_list {
  @apply flex items-center justify-between w-full border border-gray-400/40 bg-primary-blue/5 px-2 py-2 mt-2
}

.places_wrapper {
  @apply w-full lg:w-[48%]
}
</style>